<template>
  <div>
    <ul>
      <li>
        <div @click="isOpen = !isOpen;getSubFolder(folders)">
          <span v-if="isFolder" class="is-size-3">
            <i
              v-show="$_.get(folders,'attributes.objectCount',0) > 0" class="mr-2 ml-6"
              :class="isOpen? 'icon-disclosearrow':'icon-disclosearrowright'"
            ></i>
            <i
              class="icon-folder-open has-text-info mr-2"
              :class="{'ml-4': !$_.get(folders,'attributes.objectCount',0) > 0 }"
            ></i>
            <span
              class="is-size-3 has-text-weight-bold"
            >{{$_.get(folders,'attributes.displayName','')}}</span>
          </span>
          <span v-else class="ml-6 mt-2">
            <o-radio
              class="permission-radio ml-4"
              v-model="radio"
              name="name"
              :native-value="folders.id"
              @update:modelValue="getSubFolder(folders)"
            >
              <span class="is-size-3">{{$_.get(folders,'attributes.displayName','')}}</span>
            </o-radio>
          </span>
        </div>
        <ul v-show="isOpen" v-if="isFolder" class="ml-5">
          <li>

            <FolderList
            class="item"
            v-for="folder in folders.childrens"
            :key="folder.id"
            :folders="folder"
            :project="project"
            :folderInfo="getFolderInfo"
            :selectedProject="selectedProject"
            @set-itemData="$emit('set-itemData',$event)"
            ></FolderList>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import _ from 'lodash';
import Forge from '@/models/Forge';

const selectedFolderRadio = ref(null);

export default defineComponent({
  name: 'FolderList',
  components: {},
  props: {
    folders: {
      type: Object,
      default: () => ({}),
    },
    selectedProject: {
      type: Object,
      default: () => ({}),
    },
    project: {
      type: Object,
      default: () => ({}),
    },
    folderInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const subFolders = ref([]);
    const isOpen = ref(false);
    const radio = selectedFolderRadio;
    const isFolder = computed(() => _.get(props.folders, 'type') === 'folders');

    const getFolderInfo = computed(() => {
      if (
        isFolder.value
        && _.get(props.folders, 'attributes.objectCount', 0) > 0
        && isOpen.value
      ) {
        return props.folders;
      }
      return {};
    });

    const getSubFolder = async (item) => {
      if (
        isFolder.value
        && _.get(props.folders, 'attributes.objectCount', 0) > 0
        && isOpen.value
      ) {
        const params = {
          projectId: props.selectedProject.id,
          folderId: props.folders.id,
        };
        subFolders.value = await Forge.getFolderContents(params);
        _.map(subFolders.value, (folder) => {
          folder.childrens = [];
          folder.path = `${item.path}/${props.folders.attributes.displayName}`;
          return folder;
        });
        props.folders.childrens = subFolders.value;
      } else if (!isFolder.value) {
        const data = {
          item,
          folderInfo: props.folderInfo,
        };
        emit('set-itemData', data);
      }
    };

    return {
      subFolders,
      isOpen,
      radio,
      isFolder,
      getFolderInfo,
      getSubFolder,
    };
  },
});
</script>

<style scoped>
::v-deep(.o-radio [type="radio"]:checked),
::v-deep(.o-radio [type="radio"]:not(:checked)) {
  left: unset !important;
  background-color: #fff !important;
  position: relative !important;
}

/* ::v-deep(.o-radio .o-radio__label) {
  margin-left: 16px;
} */

::v-deep(.permission-radio .o-radio__check) {
  border: 1px solid #000 !important;
  background-image: url() !important;
}

::v-deep(.permission-radio .o-radio__check--checked) {
  border-color: 1px solid #000 !important;
  background-color: #fff !important;
}

::v-deep(.permission-radio .o-radio__check--checked::after) {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #000 !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

::v-deep(.permission-radio .o-radio__label) {
  color: #333333;
}
</style>
